<script>
    import { navigate } from "svelte-routing";
    import { _ } from 'svelte-i18n';
    import Button from '../Button.svelte';
    import SelectionBoxes from './SelectionBoxes.svelte';
    import { selectedMuscleGroups } from './stores/muscleGroupStore';

    const setCerebral = () => selectedMuscleGroups.set([1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]);
    const setNeuromuscular = () => selectedMuscleGroups.set([2, 4, 5, 7, 8, 9, 10, 11, 12, 13, 14]);
</script>

<style>
    .muscle-selection {
        max-width: 530px;
        margin: auto;
    }

    .selection {
        margin: var(--spacingLarge) 0 0;
        display: flex;
        flex-direction: column;
        max-height: 23rem;
        flex-wrap: wrap;
        align-content: space-between;
    }

    .button-row {
        text-align: right;
        margin-top: var(--spacingLarge);
    }

    .end-separator {
        margin-top: var(--spacingLarge);
    }

    .arrow-right {
        right: 10px;
    }

    @media screen and (max-width: 500px) {
        .selection {
            height: auto;
            align-content: center;
            max-height: none;
        }
    }

</style>

<div class="muscle-selection">
    <h2>{$_('calculator.choose.title')}</h2>

    <p>{$_('calculator.choose.intro')}</p>

    <hr />

    <div class="selection">
        <svelte:component this={SelectionBoxes} />
    </div>

    <Button width=100% on:click={setCerebral}>{$_('calculator.choose.musclegroup_1')}</Button>
    <Button width=100% on:click={setNeuromuscular}>{$_('calculator.choose.musclegroup_2')}</Button>

    <hr class="end-separator" />

    <div class="button-row">
        <Button width=230px on:click={() => navigate('/calculator-1')}>
            {$_('calculator.button_next')}
            <span class="arrow arrow-right"></span>
        </Button>
    </div>
</div>
